function section_slider(next_btn,prev_btn,slider_item,slider_list){
  let next = document.querySelector(next_btn);
  let prev = document.querySelector(prev_btn);

  let sliderwidth = document.querySelector(slider_item);
  let width = sliderwidth.clientWidth;

  let sliderlist = document.querySelector(slider_list);
  let sliderlist_item = document.querySelectorAll(slider_item);
  let last_item = sliderlist_item[sliderlist_item.length -1];
  

  let counter = 0;
  next.addEventListener("click", function(){
    let r = (last_item.getBoundingClientRect()).right ;
    if ((counter == sliderlist_item.length - 1) || (window.innerWidth >= r)) return;
    // if(counter == sliderlist_item.length - 1) return;
    prev.style.display = "block";
    sliderlist.style.transition = ".3s";
    counter ++;
    sliderlist.style.transform = "translateX("+ (- width * counter) + "px)";
  });

  prev.addEventListener("click", function(){
    if(counter == sliderlist_item.length - sliderlist_item.length) return;
    next.style.display = "block";
    sliderlist.style.transition = ".3s";
    counter --;
    sliderlist.style.transform = "translateX("+ (- width * counter) + "px)";
  });
};
function cartPageInit() {
  async function changeCartQty(key,quantity) {
    _cart_Ajax = function () {
      this.initialize = function () {
        this.xhr = new XMLHttpRequest();
      };
      this.post = function (url, data, success = function () {}, fail = function () {}) {
        this.xhr.onreadystatechange = function () {
          if (this.readyState == XMLHttpRequest.DONE) {
            if (this.status == 200) {
              success(this);
            } else {
              fail(this);
            }
          }
        };
        this.xhr.open("POST", url);
        this.xhr.setRequestHeader("Content-Type", "application/json");
        this.xhr.send(JSON.stringify(data));
      };
      this.getJSON = function (url, success = function () {}, fail = function () {}) {
        this.xhr.onreadystatechange = function () {
          if (this.readyState == XMLHttpRequest.DONE) {
            if (this.status == 200) {
              success(JSON.parse(this.responseText));
            } else {
              fail(this);
            }
          }
        };
        this.xhr.open("GET", url);
        this.xhr.send();
      };
      this.initialize();
    };
    _cart_Ajax = new _cart_Ajax();
    return new Promise(async function (resolve, reject) {
      let obj = {
        'id': key,
        'quantity':quantity
      }
      await _cart_Ajax.post('/cart/change.js', obj, async function(data) {
        if (data.status == 200) {
          let cart = JSON.parse(data.response);
          return resolve(cart);
        }
        return resolve(null);
      });
    });
  }
  let cart_qties = document.querySelectorAll('.quantity__input');
  for (let a = 0; a < cart_qties.length; a++) {
    cart_qties[a].addEventListener('change', async function(e) {
      let idx = String(e.target.id).replace('Quantity-', "");
      document.getElementById("loader-" + idx).classList.remove('hidden');
      document.getElementById("loader-" + idx + "-sp").classList.remove('hidden');
      let qb = document.querySelectorAll('.quantity__button');
      for (let b = 0; b < qb.length; b++) {
        qb[b].setAttribute('disabled', 'disabled');
      }
      let qi = document.querySelectorAll('.quantity__input');
      for (let b = 0; b < qi.length; b++) {
        qi[b].setAttribute('disabled', 'disabled');
      }
      let max = document.getElementById(e.target.id + '-max').value;
      let key = document.getElementById('CartItem-' + idx + '-key').value;
      if (isNaN(e.target.value)) {
        e.target.value = 1;
      } else if (Number(e.target.value) > Number(max)) {
        e.target.value = max;
      }
      let cart = await changeCartQty(key, e.target.value);
      if (cart) {
        if (cart['item_count'] == 0) {
          window.location.href = '/cart';
        }
        let counts = document.querySelectorAll('.ohp-right-icon-cart-count');
        for (let b = 0; b < counts.length; b++) {
          counts[b].innerText = cart['item_count'];
        }
        if (e.target.value == 0) {
          document.getElementById('CartItem-' + idx).remove();
        }
        let items = cart["items"];
        let item = items.filter(i => i.key == key);
        if (item.length == 1) {
          let flp = (Number(item[0]['final_line_price']) / 100).toLocaleString(); 
          let flps = document.querySelectorAll('.FLP-' + idx);
          for (let b = 0; b < flps.length; b++) {
            flps[b].innerHTML = '<span class="price__prefix">¥</span>' + flp;
          }
          let olp = (Number(item[0]['original_line_price']) / 100).toLocaleString(); 
          let olps = document.querySelectorAll('.OLP-' + idx);
          for (let b = 0; b < olps.length; b++) {
            olps[b].innerHTML = '<span class="price__prefix">¥</span>' + olp;
          }
        }
        let tp = (Number(cart['total_price']) / 100).toLocaleString();
        let tps = document.querySelectorAll('.totals__subtotal-value');
        for (let b = 0; b < tps.length; b++) {
          tps[b].innerText = '¥' + tp + ' JPY';
        }
      }
      for (let b = 0; b < qb.length; b++) {
        qb[b].removeAttribute('disabled');
      }
      qi = document.querySelectorAll('.quantity__input');
      for (let b = 0; b < qi.length; b++) {
        qi[b].removeAttribute('disabled');
      }
      document.getElementById("loader-" + idx).classList.add('hidden');
      document.getElementById("loader-" + idx + "-sp").classList.add('hidden');
    });
  }
}

function headerInit() {
  function outJudgeCategory(e) {
    let is = false;
    for (let b = 0; b < e.toElement.classList.length; b++) {
      if (e.toElement.classList[b] == 'ctgry-mdl') {
        is = true;
        break;
      }
    }
    if (is == false) {
      document.getElementById('ohp-category-modal').classList.remove('menu_fadein');
      let el2 = document.querySelectorAll('.ohp-center-category-hover-img');
      for (let b = 0; b < el2.length; b++) {
        el2[b].classList.remove('arrow-rotate');
      }
    }
  }
  function removeBoldActionCategory() {
    let cms = document.querySelectorAll('.ohp-center-category-hover');
    for (let a = 0; a < cms.length; a++) {
      let el = cms[a];
      el.classList.remove('fw-bold');
    }
  }
  let cms = document.querySelectorAll('.ohp-center-category-hover');
  for (let a = 0; a < cms.length; a++) {
    let el = cms[a];
    el.addEventListener('mouseover', function(e) {
      document.getElementById('ohp-category-modal').classList.add('menu_fadein');
      let el2 = document.querySelectorAll('.ohp-center-category-hover-img');
      for (let b = 0; b < el2.length; b++) {
        el2[b].classList.add('arrow-rotate');
      }
    });
    el.addEventListener('mouseout', function(e) {
      outJudgeCategory(e);
    });
  }
  let cmsi = document.getElementById('ohp-category-modal');
  cmsi.addEventListener('mouseout', function(e) {
    outJudgeCategory(e);
  });
  function outJudgeBrand(e) {
    let is = false;
    for (let b = 0; b < e.toElement.classList.length; b++) {
      if (e.toElement.classList[b] == 'brnd-mdl') {
        is = true;
        break;
      }
    }
    if (is == false) {
      document.getElementById('ohp-brand-modal').classList.remove('menu_fadein');
      let el2 = document.querySelectorAll('.ohp-center-brand-hover-img');
      for (let b = 0; b < el2.length; b++) {
        el2[b].classList.remove('arrow-rotate');
      }
    }

  }
  function removeBoldActionBrand() {
    let bms = document.querySelectorAll('.ohp-center-brand-hover');
    for (let a = 0; a < bms.length; a++) {
      let el = bms[a];
      el.classList.remove('fw-bold');
    }
  }
  let bms = document.querySelectorAll('.ohp-center-brand-hover');
  for (let a = 0; a < bms.length; a++) {
    let el = bms[a];
    el.addEventListener('mouseover', function(e) {
      document.getElementById('ohp-brand-modal').classList.add('menu_fadein');
      let el2 = document.querySelectorAll('.ohp-center-brand-hover-img');
      for (let b = 0; b < el2.length; b++) {
        el2[b].classList.add('arrow-rotate');
      }
    });
    el.addEventListener('mouseout', function(e) {
      outJudgeBrand(e);
    });
  }
  let bmsi = document.getElementById('ohp-brand-modal');
  bmsi.addEventListener('mouseout', function(e) {
    outJudgeBrand(e);
  });
  function closeAllAcc() {
    let el = document.querySelectorAll('.hmbrgr-menu-accordion-wrap');
    for (let a = 0; a < el.length; a++) {
      el[a].classList.remove('accordion-open');
    }
  }
  let hm = document.getElementById('ohs-humburger');
  hm.addEventListener('click', function(e) {
    closeAllAcc();
    hm.classList.toggle('hm-active');
    document.getElementById('hmbrgr-menu').classList.toggle('header-hide');
  });

  let hmls = document.querySelectorAll('.hmbrgr-menu-link-acc');
  for (let a = 0; a < hmls.length; a++) {
    let el = hmls[a];
    el.addEventListener('click', function(e) {
      let cnc = el.childElementCount;
      for (let b = 0; b < cnc; b++) {
        for (let c = 0; c < el.children[b].classList.length; c++) {
          if (el.children[b].classList[c] == 'hmbrgr-menu-img') {
            el.children[b].classList.toggle('open-accordion-arrow');
            break;
          }
        }
      }
      let ne = el.nextElementSibling;
      ne.classList.toggle('accordion-open');
    });
  }

  let oss = document.querySelectorAll('.oh-search-start');
  let osf = document.querySelectorAll('.oh-search-fin');
  let os = document.getElementById('oh-search-field');
  for (let a = 0; a < oss.length; a++) {
    let el = oss[a];
    el.addEventListener('click', function(e) {
      os.classList.remove('header-hide');
      el.classList.add('header-hide');
      for (let b = 0; b < osf.length; b++) {
        osf[b].classList.remove('header-hide');
      }

    });
  }
  for (let a = 0; a < osf.length; a++) {
    let el = osf[a];
    el.addEventListener('click', function(e) {
      os.classList.add('header-hide');
      el.classList.add('header-hide');
      for (let b = 0; b < oss.length; b++) {
        oss[b].classList.remove('header-hide');
      }
    });
  }

  function hideAndShowAnnbar(annbar, ohpbox, ohsbox) {
    let clientRect = annbar.getBoundingClientRect();
    let y = clientRect.bottom;
    let h = ohpbox.clientHeight;
    let h2 = ohsbox.clientHeight;
    if (y < 0) {
      document.querySelectorAll('.ohp-box')[0].style.cssText = 'top: 0px !important;';
      document.querySelectorAll('.ohs-box')[0].style.cssText = 'top: 0px !important;';
      document.getElementById('ohp-category-modal').style.cssText = 'top: ' + h + 'px !important;';
      document.getElementById('ohp-brand-modal').style.cssText = 'top: ' + h + 'px !important;';
      document.getElementById('hmbrgr-menu').style.cssText = 'top: ' + h2 + 'px !important;';
    } else if (y >= 0 && y <= annbar.clientHeight) {
      document.querySelectorAll('.ohp-box')[0].style.cssText = 'top: ' + y + 'px !important;';
      document.querySelectorAll('.ohs-box')[0].style.cssText = 'top: ' + y + 'px !important;';
      let hy = h + y;
      document.getElementById('ohp-category-modal').style.cssText = 'top: ' + hy + 'px !important;';
      document.getElementById('ohp-brand-modal').style.cssText = 'top: ' + hy + 'px !important;';
      let h2y = h2 + y;
      document.getElementById('hmbrgr-menu').style.cssText = 'top: ' + h2y + 'px !important;';
    }
  }

  let annbar = document.getElementById('shopify-section-announcement-bar');
  let ohpbox = document.getElementById('ohp-box');
  let ohsbox = document.getElementById('ohs-box');
  if (annbar && ohpbox && ohsbox) {
    hideAndShowAnnbar(annbar, ohpbox, ohsbox);
    window.addEventListener('scroll', function() {
      hideAndShowAnnbar(annbar, ohpbox, ohsbox);
    });
  }

  let ohpcls = document.querySelectorAll('.ohp-center-link');
  for (let a = 0; a < ohpcls.length; a++) {
    let u = location.href;
    if (u.includes(ohpcls[a].href)) {
      ohpcls[a].classList.add('fw-bold-ev');
    }
  }

  let citems = document.querySelectorAll('.ohp-category-modal-right-item');
  for (let a = 0; a < citems.length; a++) {
    let u = location.href;
    if (u.includes(citems[a].href)) {
      for (let b = 0; b < cms.length; b++) {
        let el = cms[b];
        el.classList.add('fw-bold-ev');
      }
    }
  }

  let bitems = document.querySelectorAll('.ohp-brand-modal-right-top');
  for (let a = 0; a < bitems.length; a++) {
    let u = location.href;
    if (u.includes(bitems[a].href)) {
      for (let b = 0; b < bms.length; b++) {
        let el = bms[b];
        el.classList.add('fw-bold-ev');
      }
    }
  }
  let bitemss = document.querySelectorAll('.ohp-brand-modal-right-btml');
  for (let a = 0; a < bitemss.length; a++) {
    let u = location.href;
    if (u.includes(bitemss[a].href)) {
      for (let b = 0; b < bms.length; b++) {
        let el = bms[b];
        el.classList.add('fw-bold-ev');
      }
    }
  }
  let bitemsss = document.querySelectorAll('.ohp-brand-modal-right-btmr');
  for (let a = 0; a < bitemsss.length; a++) {
    let u = location.href;
    if (u.includes(bitemsss[a].href)) {
      for (let b = 0; b < bms.length; b++) {
        let el = bms[b];
        el.classList.add('fw-bold-ev');
      }
    }
  }

};
